import { NgModule } from '@angular/core';

import { TmsLibModule } from '../../tms-shared';
import { RoleComponent, RoleDetailsComponent, RoleMenuItemsComponent, RolesComponent } from './components';
import { RoleRoutingModule } from './role-routing.module';

@NgModule({
  declarations: [RoleComponent, RoleDetailsComponent, RoleMenuItemsComponent, RolesComponent],
  imports: [TmsLibModule, RoleRoutingModule],
})
export class RoleModule {}
